import { render } from "./ContractorCompanyUserItem.vue?vue&type=template&id=19d42634&scoped=true&ts=true"
import script from "./ContractorCompanyUserItem.vue?vue&type=script&lang=ts"
export * from "./ContractorCompanyUserItem.vue?vue&type=script&lang=ts"

import "./ContractorCompanyUserItem.vue?vue&type=style&index=0&id=19d42634&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19d42634"]])

export default __exports__